import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroFlowPageComponent } from './intro-flow-page.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LightImageModule } from '../light-image/light-image.module';
import { SvgMorphModule } from '../svg-morph/svg-morph.module';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { GroupInitialModule } from '../group-initial/group-initial.module';
import { GroupOverviewModule } from '../group-overview/group-overview.module';
import { TutorialAnimationModule } from '../tutorial-animation/tutorial-animation.module';
import { MotesMediaModule } from '../motes-media/motes-media.module';

@NgModule({
    declarations: [IntroFlowPageComponent],
    imports: [
        CommonModule,
        SvgIconModule,
        SvgMorphModule,
        LightImageModule,
        MotePipesModule,
        GroupInitialModule,
        GroupOverviewModule,
        TutorialAnimationModule,
        MotesMediaModule
    ],
    exports: [IntroFlowPageComponent]
})
export class IntroFlowPageModule { }
